import React, { useEffect, useState } from 'react';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { styles } from './CarouselMainSnackbars.css';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { SnackbarProps } from '../Contentful/transformers/SnackbarTransformer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Cookies from 'js-cookie';
import { getSortedList } from '@jbhi-fi/utils/src/sorting/sortOnPriority';

const COOKIE_KEY_PREFIX = 'dismissed-snackbar-';

export const CarouselMainSnackbars = ({ items }: { items: Array<SnackbarProps> }) => {
  const [mainSnackbars, setSnackbars] = useState<Array<SnackbarProps>>([]);

  useEffect(() => {
    const dismissedSnackbars = items
      .map(item => {
        const cookieKey = `${COOKIE_KEY_PREFIX}-${item.name}`;
        const cookieValue = Cookies.get(cookieKey);
        return cookieValue ? item.name : null;
      })
      .filter(Boolean) as Array<string>;
    const sortedItems = getSortedList(items, 10);
    const filteredSnackbars = sortedItems.filter(snackbar => {
      return !dismissedSnackbars.includes(snackbar.name);
    });
    setSnackbars(filteredSnackbars);
  }, [items]);

  const handleClose = (snackbar: SnackbarProps) => {
    const { name, showAgainAfter } = snackbar;
    const cookieKey = `${COOKIE_KEY_PREFIX}-${name}`;
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + (showAgainAfter ?? 0));
    Cookies.set(cookieKey, 'dismissed', { expires: expiryDate });
    setSnackbars(prevSnackbars => prevSnackbars.filter(sb => sb.name !== name));
  };

  const carouselClass = mainSnackbars.length > 1 ? 'default' : styles.mainSnackbarSlider;

  const getMainSnackbarContent = () => {
    const isNonDismissable = mainSnackbars.some(snackbar => snackbar?.dismissible === false) ?? false;

    return mainSnackbars?.map((snackbar: SnackbarProps) => {
      return (
        <div
          key={snackbar.name}
          className={styles.mainSnackbarItems}
          style={{ backgroundColor: snackbar.backgroundColor, color: snackbar.textColor }}
        >
          <div className={styles.mainSnackbarContent}>
            {snackbar.icon ? (
              <Icon name={snackbar.icon} className={styles.mainSnackbarIcon} height="24px" width="24px" color="white" />
            ) : null}
            {snackbar.content ? (
              <div className={styles.mainSnackbarContentColor} style={{ color: snackbar.textColor || 'black' }}>
                {documentToReactComponents(snackbar.content)}
              </div>
            ) : null}
          </div>
          {!isNonDismissable ? (
            <Button
              onClick={() => handleClose(snackbar)}
              type="iconOnly"
              aria-label="Close"
              className={styles.mainSnackbarItemsButton}
            >
              <Icon name="Close" />
            </Button>
          ) : null}
        </div>
      );
    });
  };

  if (!mainSnackbars?.length) return null;

  return (
    <div className={styles.mainSnackbarWrapper} id="snackbar-main" data-testid="snackbar-main">
      <Carousel
        slidesOffsetBefore={1}
        slidesOffsetAfter={1}
        showPagination={false}
        variant={mainSnackbars.length > 1 ? 'autoPlayCarousel' : 'default'}
        centeredSlides={false}
        showArrows={false}
        fullBleed
        className={carouselClass}
      >
        {getMainSnackbarContent()}
      </Carousel>
    </div>
  );
};
